import React, { useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
// import {
//   Box,
//   HStack,
//   Heading,
//   FormControl,
//   FormLabel,
//   Input,
//   SimpleGrid,
//   Radio,
//   RadioGroup,
//   Stack,
//   Button,
//   Text,
//   Flex,
//   FormHelperText,
// } from "@chakra-ui/react";
import Loading from "../loading";
import axios from "axios";
import Slider, { SliderTooltip } from "rc-slider";
import { BsCloudUpload } from "react-icons/bs";
import { FaEquals } from "react-icons/fa";
import { FcApproval } from "react-icons/fc";
import { useMediaQuery } from "@chakra-ui/media-query";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import CSVReader from "react-csv-reader";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DateTimePicker from "react-datetime-picker";
import { Link } from "react-router-dom";
import moment from "moment";
import BuySale from "./Close";
import { Grid, Box, Avatar, Container } from "@material-ui/core";
import { Heading } from "@chakra-ui/react";

const Sales = () => {
  const {
    userWalletAddress = "",
    network = "",
    bnbBalance = 0,
    salesContract = "",
    data,
    web3,
  } = useSelector((state) => state.UserReducer);
  const [style, setStyle] = React.useState({});
  const [remaining, setremaining] = useState(0);
  const [loading, setloading] = useState(false);
  const [comingSoon, setcomingSoon] = useState([]);
  const [close, setclose] = useState([]);
  const [open, setopen] = useState([]);
  const { spacing } = useTheme();
  const [isnotSmallScreen] = useMediaQuery("(min-width:600px)");
  React.useEffect(() => {
    setTimeout(() => {
      const newStyle = {
        opacity: 0.8,
        width: `${remaining}%`,
        fontSize: "10px",
      };

      setStyle(newStyle);
    }, 200);

    var close = data.filter(({ projectStatus }) => projectStatus == "close");
    setclose([...close]);
  }, [data]);
  return (
    <React.Fragment>
      <Loading open={loading} />
      <Box mt={spacing(1)}>
        <Container maxWidth="lg">
          <Box component="h3" align="center">
            {" "}
            <Heading
              color="#00B7C5"
              fontSize={isnotSmallScreen ? "2xl" : "1xl"}
              py={10}
            >
              Closed Sales
            </Heading>
          </Box>
          <Grid container spacing={3}>
            {close.length !== 0 ? (
              close.map((item, index) => <BuySale data={item} />)
            ) : (
              <Heading color="black" fontSize="xl" py={10}>
                No Sale is closed yet
              </Heading>
            )}
          </Grid>
        </Container>
      </Box>
    </React.Fragment>
  );
};

export default Sales;
